import { CONTENTS_NXT_CONSTANTS } from '@flows/configs/contentsNxt/constants'
import { DEDUCTIBLE_INFO } from '@flows/configs/shared/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_ContentsV1GetsafeDe } from '@flows/insurance/schemas'

const contents_deductibles = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('deductible_amount')]:
        BaseSchema_ContentsV1GetsafeDe.shape.deductible_amount,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.contents_deductibles.title',
        },
      },
      {
        type: 'choice',
        name: params.helperFunctions.getParamPath('deductible_amount'),
        options: CONTENTS_NXT_CONSTANTS.deductiblesOptions.map((option) => {
          return {
            label: {
              type: 'nonTranslatableText',
              text: params.clientHelpers.formatter.formatCurrency(option),
            },
            value: Number(option),
          }
        }),
      },
      DEDUCTIBLE_INFO(),
    ],
    subFlow: params.subFlow,
    nextStep: 'contents_bike',
  }) as const satisfies AnyStepConfiguration

export default contents_deductibles
